import React, { FunctionComponent } from "react";
import classNames from "classnames";

import styles from "./Icon.module.css";

type TProps = {
  name:
    | "360"
    | "adb"
    | "cameraswitch"
    | "settings"
    | "blur_on"
    | "videocam"
    | "fullscreen"
    | "fullscreen_exit"
    | "book"
    | "line_axis"
    | "undo"
    | "format_size"
    | "border_color"
    | "opacity"
    | "help"
    | "keyboard_arrow_left"
    | "keyboard_arrow_right"
    | "keyboard_arrow_up"
    | "keyboard_arrow_down"
    | "keyboard_command_key"
    | "expand_more"
    | "expand_less"
    | "error"
    | "ads_click"
    | "menu_open"
    | "color_lens"
    | "info"
    | "insights"
    | "functions"
    | "filter_alt"
    | "category"
    | "arrow_upward"
    | "arrow_downward"
    | "reorder";
  color?: "light" | "dark";
  className?: string;
  outlined?: boolean;
};

const Icon: FunctionComponent<TProps> = function ({
  color = "dark",
  ...props
}) {
  return (
    <span
      className={classNames(
        {
          "material-icons": !props.outlined,
          "material-symbols-outlined": props.outlined,
          [styles.light]: color === "light",
          [styles.dark]: color === "dark",
        },
        props.className
      )}
    >
      {props.name}
    </span>
  );
};

export default Icon;
